import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import { operationalFunction } from 'components/UIBuilder/SectionFunction/Common';
import * as globalFunction from 'util/GlobalFunction';
import moment from 'moment';

export function manageGroup({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.current?.setState({ manageGroupShow: true });
  setTimeout(() => {
    sectionComponent.child.current?.manageGroup.current?.getSubJobGroupList();
  }, config.setTimeoutMilliSecond);
}

export function addSubJob({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ Notify: false, SubContractorId: 0, showModal: true, componentType: 'Create' });
  setTimeout(() => {
    let formData = parameter;
    //设置富文本的控件为空字符串，否则会崩
    formData['Directions'] = '';
    sectionComponent.customForm.current?.formRef.current?.setFieldsValue(formData);
    sectionComponent.customForm.current?.setState({ formData });

    setTimeout(() => {
      //设置联动的Select
      getSubJobGroupSelectOptionList({ sectionName: sectionName, parameter: parameter, formComponent: sectionComponent.customForm.current, sectionComponent: sectionComponent, pageComponent: pageComponent });
    }, config.setTimeoutMilliSecond);
  }, config.setTimeoutMilliSecond);
}

//弹出编辑DIV后触发
export function editSubJobPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.customForm.current?.setState({ activeKey: 0 });
  sectionComponent.setState({
    Notify: false,
    ScheduledDate: moment(sectionComponent.customForm.current?.formRef.current?.getFieldValue('ScheduledDate')).format(config.format.sqlDate),
    SubContractorId: sectionComponent.customForm.current?.formRef.current?.getFieldValue('SubContractorId')
  });
  globalFunction.setUieVisible(pageComponent, 'SubJob', 'Edit', 'OralDirectionAddTask', sectionComponent.customForm.current?.formRef.current?.getFieldValue('OralDirectionIssueDate') !== undefined);
  globalFunction.setUieVisible(pageComponent, 'SubJob', 'Edit', 'WrittenDirectionAddTask', sectionComponent.customForm.current?.formRef.current?.getFieldValue('WrittenDirectionIssueDate') !== undefined);
  setTimeout(() => {
    //设置联动的Select
    getSubJobGroupSelectOptionList({ sectionName: sectionName, parameter: parameter, formComponent: sectionComponent.customForm.current, sectionComponent: sectionComponent, pageComponent: pageComponent });
  }, config.setTimeoutMilliSecond);
}

///获取当前Group列表
export function getSubJobGroupSelectOptionList({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  httpClient
    .get('Business/SubJobGroup/GetSelectOptionList?jobId=' + formComponent.props.jobId)
    .then(({ data }) => {
      if (data.result) {
        let dataSource = data.data;
        let componentDataSource = { ...formComponent.state.componentDataSource };
        componentDataSource['GroupId'] = dataSource;
        formComponent.setState({ componentDataSource });
        if (parameter.GroupId === undefined || parameter.GroupId === null) {
          sectionComponent.customForm.current?.formRef.current?.setFieldValue('GroupId', dataSource[0]?.Value);
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

//快速填充OralDirectionExpiryDate
export function quickAddDays_OralDirectionExpiryDate({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  let date = sectionComponent.customForm.current?.formRef.current?.getFieldValue('OralDirectionIssueDate');
  if (date !== undefined) {
    sectionComponent.customForm.current?.formRef.current?.setFieldValue('OralDirectionExpiryDate', globalFunction.addDateMoment(date, parameter));
    globalFunction.setUieVisible(pageComponent, 'SubJob', 'Edit', 'OralDirectionAddTask', true);
  }
}

//OralDirectionExpiryDate改变时触发
export function oralDirectionExpiryDateChange({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  globalFunction.setUieVisible(pageComponent, 'SubJob', 'Edit', 'OralDirectionAddTask', true);
}

//OralDirectionExpiryDate清空时触发
export function clearOralDirectionExpiryDate({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  globalFunction.setUieVisible(pageComponent, 'SubJob', 'Edit', 'OralDirectionAddTask', false);
}

//快速填充WrittenDirectionExpiryDate
export function quickAddDays_WrittenDirectionExpiryDate({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  let date = sectionComponent.customForm.current?.formRef.current?.getFieldValue('WrittenDirectionIssueDate');
  if (date !== undefined) {
    sectionComponent.customForm.current?.formRef.current?.setFieldValue('WrittenDirectionExpiryDate', globalFunction.addDateMoment(date, parameter));
    globalFunction.setUieVisible(pageComponent, 'SubJob', 'Edit', 'WrittenDirectionAddTask', true);
  }
}

//WrittenDirectionExpiryDate改变时触发
export function writtenDirectionExpiryDateChange({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  globalFunction.setUieVisible(pageComponent, 'SubJob', 'Edit', 'WrittenDirectionAddTask', true);
}

//WrittenDirectionExpiryDate清空时触发
export function clearWrittenDirectionExpiryDate({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  globalFunction.setUieVisible(pageComponent, 'SubJob', 'Edit', 'WrittenDirectionAddTask', false);
}

//编辑提交后可能会刷新Task
export function editSubmitFinish({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  globalFunction.getSectionComponent(pageComponent, 'JobTask').getSectionDataByDefault();
}

//弹出mailmerge的div
export function docMergeSubJob({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ mailMergeTemplateShow: true, mailMergeObjId: parameter.SubJobId, dataModelType: 2 });
  setTimeout(() => {
    pageComponent.mailMergeTemplate.current?.getMailMergeTemplate(2);
  }, config.setTimeoutMilliSecond);
}

//设置是否发信
export function setNotify({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  let notify = sectionComponent.customForm.current?.formRef.current?.getFieldValue('Notify');
  if (notify !== true) {
    sectionComponent.setState({ Notify: true });
    sectionComponent.customForm.current?.formRef.current?.setFieldValue('Notify', true);
  } else {
    sectionComponent.setState({ Notify: false });
    sectionComponent.customForm.current?.formRef.current?.setFieldValue('Notify', false);
  }
}

//特殊处理一些提交的条件
export function submitCustomForm({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  if ((sectionComponent.state.ScheduledDate !== moment(sectionComponent.customForm.current?.formRef.current?.getFieldValue('ScheduledDate')).format(config.format.sqlDate) ||
    sectionComponent.state.SubContractorId !== sectionComponent.customForm.current?.formRef.current?.getFieldValue('SubContractorId')) &&
    sectionComponent.customForm.current?.formRef.current?.getFieldValue('ScheduledDate') !== undefined &&
    sectionComponent.customForm.current?.formRef.current?.getFieldValue('SubContractorId') != 0 &&
    sectionComponent.state.Notify !== true) {
    sectionComponent.child.current?.setState({ submitConfirmShow: true });
  } else {
    sectionComponent.customForm.current?.submitForm();
  }
}

//InspectionScheduler 上的编辑
export function editByInspectionScheduler({ parameter, sections, sectionComponent, pageComponent, sectionName, uie } = {}) {
  //先获取数据
  httpClient
    .get(pageComponent.props.areaName + '/' + sectionName + '/GetDetailWidthJob/' + parameter.key)
    .then(({ data }) => {
      if (data.result) {
        sectionComponent.setState({ showModal: true, componentType: 'Edit', renderForm: true });
        let recordData = data.data;

        //通过这条数据的 Job_ModuleId 获取控件数据源
        httpClient
          .get(sectionComponent.customForm.current?.props.component.datasourceUrl + '?moduleId=' + data.data.Job_ModuleId)
          .then(({ data }) => {
            if (data.result) {
              if (data.data.length > 0) {
                data.data.map((hash, i) => {
                  let dataSource = hash.Value;
                  let uie = null;
                  sectionComponent.customForm.current?.props.component.groupList.map((group, j) => {
                    group.uieList.map((u, k) => {
                      if (u.source == hash.Key) {
                        uie = u;
                      }
                    })
                  })
                  if (uie !== null) {
                    let componentDataSource = { ...sectionComponent.customForm.current?.state.componentDataSource };
                    if (uie.required) {
                      dataSource = dataSource.filter(item => item.Value !== 0);
                    }
                    componentDataSource[hash.Key] = dataSource;
                    sectionComponent.customForm.current?.setState({ componentDataSource });
                  }
                });

                sectionComponent.customForm.current?.setState({ currentDataKey: recordData.key });
                //处理不适合antd组件的数据
                let componentDataSource = sectionComponent.customForm.current?.state.componentDataSource;
                sectionComponent.props.section.componentList.filter(c => c.type === 'Edit')[0].groupList.forEach(group => {
                  group.uieList.forEach(uie => {
                    switch (uie.component) {
                      case 'DatePicker':
                        //处理日期, 把字符串转成moment
                        if (recordData[uie.source] !== null) {
                          recordData[uie.source] = moment(recordData[uie.source], config.format.date);
                        } else {
                          recordData[uie.source] = undefined;
                        }
                        break;
                      case 'Select':
                        //处理Select默认选项, 如果字段的值是null且备选项列表已加载, 则自动选择备选项里第一个(如果已有数据, 则加载备选项里有的那一条)
                        if (recordData[uie.source] === null && componentDataSource[uie.source] !== undefined) {
                          recordData[uie.source] = componentDataSource[uie.source][0]?.Value;
                        }
                        if (uie.autoSelect) {
                          //如果是自定义AutoSelect的类型, 触发其onChange事件
                          operationalFunction({ functionName: uie.onChange, sectionName: sectionName, parameter: recordData[uie.source], formComponent: sectionComponent.customForm.current, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie });
                        }
                        break;
                      case 'RichTextEditor':
                        //处理RichTextEditor, 如果是null或者undefined，改为空字符串，否则会崩溃
                        if (recordData[uie.source] === null) {
                          recordData[uie.source] = '';
                        }
                        break;
                      case 'Input':
                        //处理Input, 如果type是fileName, 处理成改文件名的状态
                        if (uie.type === 'fileName') {
                          uie.addonAfter = globalFunction.getExtension(recordData[uie.source]);
                          recordData[uie.source] = globalFunction.getFileNameWithoutExtension(recordData[uie.source]);
                        }
                        break;
                    }
                  });
                });
                //把处理后的数据赋值给表单
                sectionComponent.customForm.current?.formRef.current?.setFieldsValue(recordData);
                sectionComponent.customForm.current?.setState({ formData: recordData });

                try {
                  editSubJobPopUpRun({ parameter: parameter, sectionComponent: sectionComponent, pageComponent: pageComponent, sectionName: sectionName, uie: uie });
                } catch (error) { }
              }
            } else {
              globalFunction.handleResultError(data, pageComponent);
            }
          })
          .catch(function (error) {
            globalFunction.handleError(error, pageComponent);
          });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

//通过模板设置 Direction
export function setDirectionFromTemplate({ parameter, sections, formComponent, sectionComponent, pageComponent, sectionName, uie } = {}) {
  if (parameter > 0) {
    httpClient
      .get('/Admin/SubJobDirectionTemplate/' + parameter)
      .then(({ data }) => {
        if (data.result) {
          let directions = formComponent.formRef.current?.getFieldValue('Directions');
          directions = data.data.Direction + directions;
          formComponent.formRef.current?.setFieldValue('Directions', directions);
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

//打开从模板添加界面
export function addFromTemplate({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let defaultFormData = pageComponent.state.defaultFormData;
  defaultFormData.moduleId = pageComponent.state.moduleId;
  pageComponent.setState({ defaultFormData });
  openAddFromTemplate({ component: sectionComponent.child.current });
}

export function openAddFromTemplate({ component } = {}) {
  component.setState({ addFromTemplateShow: true });
  component.addFromTemplate.current?.setState({ activeKey: 0 });
  setTimeout(() => {
    component.addFromTemplate.current?.formRef.current?.resetFields();
    component.addFromTemplate.current?.additionalFormRef.current?.child.current?.setState({ defaultSelectedRowKeys: [], selectedRowKeys: [], subJobTypePresetContentList: [] });
    setTimeout(() => {
      component.addFromTemplate.current?.additionalFormRef.current?.child.current?.getSubJobTypeData();
      component.addFromTemplate.current?.getSubJobTypePresetDataSource();
    }, config.setTimeoutMilliSecond);
  }, config.setTimeoutMilliSecond);
}

export function addBookingRequest({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ subjobData: parameter, bookingRequestShow: true });
  pageComponent.bookingRequest.current?.getWebUI('Create');
}

export function editBookingRequest({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ subjobData: parameter, bookingRequestShow: true });
  pageComponent.bookingRequest.current?.getWebUI('Edit');
}
